import { render, staticRenderFns } from "./postDetails.vue?vue&type=template&id=f5f9b156&scoped=true"
import script from "./postDetails.vue?vue&type=script&lang=js"
export * from "./postDetails.vue?vue&type=script&lang=js"
import style0 from "./postDetails.vue?vue&type=style&index=0&id=f5f9b156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f9b156",
  null
  
)

export default component.exports